class DetallePedido extends HTMLElement {
  constructor() {
    super();
    this.coordenadas = { lat: -17.51041339757574, lng: -63.164604605594825 };
    this.direccionSeleccionada = false;
    this.marcadorMovible = null;
    this.estadoEtapaPagina = "";
  }

  connectedCallback() {
    // REFERENCIAS A ELEMENTOS
    this.btnVerMasDetalles = this.querySelector("#phpdp-btn-ver-mas-detalles");
    this.btnVolverInicio = this.querySelector("#phpdp-btn-volver-inicio");
    this.btnVolverAtras = this.querySelector("#phpdp-btn-volver-atras");

    this.seccionGeneralInfoBasica = this.querySelector(
      "#phpdp-seccion-general-info-basica"
    );
    this.seccionInfoBasica = this.querySelector("#phpdp-seccion-info-basica");
    this.infoBasicaDetalle = this.querySelector("#phpdp-info-basica-detalle");

    this.seccionInfoEntregaLocal = this.querySelector(
      "#phpdp-detalle-pedido-local"
    );
    this.seccionInfoEntregaDomicilio = this.querySelector(
      "#phpdp-detalle-envio-domicilio"
    );
    this.seccionNotaDeEnvio = this.querySelector("#phpdp-seccion-nota-envio");
    this.etiquetaNotaDeEnvio = this.querySelector("#phpdp-etiqueta-nota-envio");
    this.seccionDragonTail = this.querySelector("#phpdp-seccion-dragon-tail");

    this.seccionSuperiorDetallePedido = this.querySelector(
      "#phpdp-seccion-superior-detalle-pedido"
    );
    this.etiquetaTotalPrecioSuperior = this.querySelector(
      "#phpdp-etiqueta-totalPedido"
    );
    this.infoSuperiorDetallePedido = this.querySelector(
      "#phpdp-info-superior-detalle-pedido"
    );
    this.etiquetaIdShopifyOrder = this.querySelector(
      "#phpdp-etiqueta-idshopify-order"
    );
    this.etiquetaSubTotal = this.querySelector("#phpdp-etiqueta-subtotal");
    this.etiquetaTotal = this.querySelector("#phpdp-etiqueta-total");

    this.seccionInferiorDetallePedido = this.querySelector(
      "#phpdp-seccion-inferior-detalle-pedido"
    );
    this.etiquetaTipoMetodoEntrega = this.querySelector(
      "#phpdp-etiqueta-metodo-entrega"
    );
    this.seccionDetalleLocal = this.querySelector(
      "#pdpph-seccion-detalle-inferior-local"
    );
    this.seccionDetalleDomicilio = this.querySelector(
      "#pdpph-seccion-detalle-inferior-domicilio"
    );
    this.seccionPedidoCliente = this.querySelector(
      "#phpdp-empieza-seccion-pedido"
    );

    this.seccionMetodoPago = this.querySelector("#phpdp-metodo-pago");
    this.btnAbirUbicacionMapa = this.querySelectorAll("#phpdp-btn-abrir-mapa");

    // EVENTOS INICIALIZAR
    this.btnVerMasDetalles.addEventListener(
      "click",
      this.btnVerMasDetallesClick.bind(this)
    );
    this.btnVolverInicio.addEventListener(
      "click",
      this.btnVolverInicioClick.bind(this)
    );
    this.btnVolverAtras.addEventListener(
      "click",
      this.btnVolverAtrasClick.bind(this)
    );
    this.btnAbirUbicacionMapa.forEach((btn) => {
      btn.addEventListener("click", this.btnAbirUbicacionMapaClick.bind(this));
    });
    this.inicializarDataLocalStorage();
  }


  reproducirAudioFinalizar() {
    if (!this.debeReproducirAudio) return;

    const audio = document.getElementById("audio-finalizar-compra");
    if (audio) {
      setTimeout(() => {
        audio
          .play()
          .catch((err) => {
            console.warn("Audio finalizar bloqueado por el navegador:", err);
          });
      }, 500);
    }
  }

  async inicializarDataLocalStorage() {
    this.debeReproducirAudio = localStorage.getItem("ph-viene-de-compra-finalizada") === "1";
    localStorage.removeItem("ph-viene-de-compra-finalizada");
    this.estadoEtapaPagina = localStorage.getItem("ph-estadoDP");
    const idOrdenTrabajo = localStorage.getItem("ph-id-orden");
    const url_dragontail = localStorage.getItem("ph-dragontail");

    // Solo consideramos error si falta el estado de la página o el id de la orden.
    // La ausencia de url_dragontail ya no provoca redirección al home.
    if (
      this.estadoEtapaPagina == null ||
      idOrdenTrabajo == null
    ) {
      window.location.href = "/";
      return;
    }

    MensajeCargaDatos.mostrar("Cargando informacion ...");
    // gid://shopify/Order/6148145873075
    var info_completa_orden = null;
    // if(window.produccion == "si"){
    //   info_completa_orden = await GestionOrdenesShopify.getDetalleCompletoOrdenLocal(idOrdenTrabajo.split('/').pop());
    // }else{
    // }
    info_completa_orden =
      await GestionOrdenesShopify.getDetalleCompletoOrdenREST(
        idOrdenTrabajo.split("/").pop()
      );

    this.coordenadas = (([lat, lng]) => ({ lat, lng }))(
      info_completa_orden.cc_coordenadas.split(",")
    );

    const metodoEntrega = info_completa_orden.metodo_entrega;
    const idShopifyOrder = info_completa_orden.nro;

    if (this.estadoEtapaPagina == "etapa-1") {
      this.seccionGeneralInfoBasica.style.display = "flex";
      this.btnVolverInicio.style.display = "flex";
      this.btnVerMasDetalles.style.display = "flex";

      const etiquetaInfoBasica = this.seccionInfoBasica.querySelector(
        "#phpdp-etiqueta-tipo-pedido"
      );
      etiquetaInfoBasica.textContent = metodoEntrega;
      const contenedorIcono = this.seccionInfoBasica.querySelector(
        ".pdpph-mensaje-etapa1-icono"
      );
      contenedorIcono.innerHTML =
        metodoEntrega == "Envío a Domicilio"
          ? `${window.shopIcons.icon_recogo_delivery}`
          : `${window.shopIcons.icon_recogo_local}`;

      // Solo necesito obtener los numeros
      const { fechaFormateada, horaCompletada } = this.formatearFechaInfoBasica(
        info_completa_orden.tiempo_creacion
      );

      this.infoBasicaDetalle.innerHTML = `
                <h3>Nº de pedido ${info_completa_orden.nro}</h3>
                <h3>ESTARA LISTO A las ${horaCompletada}</h3>
                <h3>fecha ${fechaFormateada}</h3>
            `;
    }

    if (this.estadoEtapaPagina == "etapa-2") {
      this.btnVolverAtras.style.display = "flex";
      this.seccionSuperiorDetallePedido.style.display = "flex";
      this.seccionInferiorDetallePedido.style.display = "flex";
    }

    const textosCombos = this.formatoTextosCombos(
      info_completa_orden.total_items
    );
    this.etiquetaIdShopifyOrder.textContent = `#${idShopifyOrder}`;
    this.infoSuperiorDetallePedido.innerHTML = `
            <p>${textosCombos}</p>
            <p>•</p>
            <p>
              Pedido realizado: ${info_completa_orden.tiempo_creacion}
            </p>
        `;

    this.etiquetaTotalPrecioSuperior.textContent = `${parseInt(
      info_completa_orden.total
    )} Bs`;
    this.etiquetaTipoMetodoEntrega.textContent =
      metodoEntrega == "Envío a Domicilio"
        ? "Envío a Domicilio"
        : "Pedido en Local";
    metodoEntrega == "Envío a Domicilio"
      ? (this.seccionInfoEntregaDomicilio.style.display = "flex")
      : (this.seccionInfoEntregaLocal.style.display = "flex");
    if (metodoEntrega == "Envío a Domicilio") {
      this.seccionInfoEntregaDomicilio.insertAdjacentHTML(
        "afterbegin",
        `
        <h3>${info_completa_orden.alias}</h3>
        <h4>${info_completa_orden.indicaciones}</h4>
      `
      );

      this.seccionInfoEntregaDomicilio.style.display = "flex";
    } else {
      const localEncontrado = window.sucursales.find(
        (local) => local.nombre == info_completa_orden.local_designado
      );

      this.seccionInfoEntregaLocal.insertAdjacentHTML(
        "afterbegin",
        `
        <h3 class="color-letras-primary">${localEncontrado.nombre}</h3>
        <div class="pdpph-etapa2-info-local">
          ${window.shopIcons.icon_location_on}
        <p>${localEncontrado.localizacion}</p>
        </div>
        <div class="pdpph-etapa2-info-local">
          ${window.shopIcons.icon_headser_mic}
          <p>+591 ${localEncontrado.telefono}</p>
        </div>
      `
      );
      this.seccionInfoEntregaLocal.style.display = "flex";
    }

    const metodoPago = info_completa_orden.metodo_pago;
    if (metodoPago == "Pago Codigo QR") {
      this.seccionMetodoPago.innerHTML = `
      ${window.shopIcons.icon_qr}
      <p class="color-letras-extra">
        Pago mediante QR
      </p>
      `;
    }
    if (metodoPago == "Pago Tarjeta") {
      this.seccionMetodoPago.innerHTML = `
      ${window.shopIcons.icon_tarjeta_credito}
      <p class="color-letras-extra">
        Pago mediante tarjeta de credito
      </p>
      `;
    }

    if (metodoPago == "Pago Efectivo") {
      this.seccionMetodoPago.innerHTML = `
      ${window.shopIcons.icon_dolar}
      <p class="color-letras-extra">
        Pago en efectivo
      </p>
      `;
    }

    this.etiquetaSubTotal.textContent = `${parseInt(info_completa_orden.total) -
      (metodoEntrega == "Envío a Domicilio"
        ? parseInt(window.costoEnvioDomicilio)
        : 0)
      } Bs`;
    this.etiquetaEntrega = this.querySelector("#phpdp-etiqueta-gastos-envio");
    this.etiquetaEntrega.textContent =
      metodoEntrega == "Envío a Domicilio"
        ? `${parseInt(window.costoEnvioDomicilio)} Bs`
        : "0 Bs";
    this.etiquetaTotal.textContent = `${info_completa_orden.total} Bs`;

    if (info_completa_orden.nota == "") {
      this.seccionNotaDeEnvio.style.display = "none";
    } else {
      this.seccionNotaDeEnvio.style.display = "flex";
      this.etiquetaNotaDeEnvio.textContent = info_completa_orden.nota;
    }

    var contenidoHTMLPedido = "";
    info_completa_orden.line_items.forEach((item) => {
      contenidoHTMLPedido += `
        <div class="container-sub-smecph">
          <div class="pdpph-etapa2-info-pedido">
            <p>${item.nombre}</p>
            <p class="color-letras-extra">Cantidad: ${item.cantidad}</p>
          </div>
          <p style="font-weight: 700;" class="color-letras-primary">${item.precio} Bs</p>
        </div>
      `;
    });

    // Configuración de DragonTail solo si existe una URL válida.
    if (url_dragontail) {
      const fechaCreacion = new Date(info_completa_orden.tiempo_creacion);
      const fechaActual = new Date();

      const esMismoDia =
        fechaCreacion.getFullYear() === fechaActual.getFullYear() &&
        fechaCreacion.getMonth() === fechaActual.getMonth() &&
        fechaCreacion.getDate() === fechaActual.getDate();

      const diferenciaMs = fechaActual - fechaCreacion;
      const diferenciaHoras = diferenciaMs / (1000 * 60 * 60);
      const hanPasado24Horas = diferenciaHoras > 24;

      if (esMismoDia) {
        this.seccionDragonTail.querySelector("iframe").src = url_dragontail;
      } else if (hanPasado24Horas) {
        this.seccionDragonTail.style.display = "none";
      } else {
        this.seccionDragonTail.style.display = "none";
      }
    } else {
      // Si no hay url_dragontail, simplemente ocultamos la sección DragonTail.
      this.seccionDragonTail.style.display = "none";
    }

    this.seccionPedidoCliente.insertAdjacentHTML(
      "afterend",
      contenidoHTMLPedido
    );
    this.reproducirAudioFinalizar();
    MensajeCargaDatos.ocultar();
  }

  // Método auxiliar para traducir el estado de la orden
  traducirEstado(estado) {
    const traducciones = {
      OPEN: "Abierta",
      COMPLETED: "Completada",
      INVOICE_SENT: "Factura Enviada",
      PENDING: "Pendiente",
    };

    return traducciones[estado] || estado;
  }

  formatearFechaInfoBasica(fechaCompletada) {
    // "2025-07-24T09:21:18-04:00" o "24/07/2025, 09:21:18"
    const meses = [
      "ene.",
      "feb.",
      "mar.",
      "abr.",
      "may.",
      "jun.",
      "jul.",
      "ago.",
      "sep.",
      "oct.",
      "nov.",
      "dic.",
    ];

    let fechaObj;
    // Detectar formato ISO
    if (fechaCompletada.includes("T")) {
      // Formato ISO
      fechaObj = new Date(fechaCompletada);
    } else {
      // Formato "24/07/2025, 09:21:18"
      const [fecha, hora] = fechaCompletada.split(", ");
      const [dia, mes, anio] = fecha.split("/");
      const [horas, minutos, segundos] = hora.split(":");
      fechaObj = new Date(
        `${anio}-${mes}-${dia}T${horas}:${minutos}:${segundos}`
      );
    }

    // Sumar 25 minutos
    fechaObj.setMinutes(fechaObj.getMinutes() + 25);

    // Formatear fecha
    const dia = fechaObj.getDate();
    const mes = meses[fechaObj.getMonth()];
    const anio = fechaObj.getFullYear();
    const fechaFormateada = `${dia} de ${mes} ${anio}`;

    // Formatear hora
    const horas = fechaObj.getHours().toString().padStart(2, "0");
    const minutos = fechaObj.getMinutes().toString().padStart(2, "0");
    const horaFormateada = `${horas}:${minutos}`;

    return {
      fechaFormateada,
      horaCompletada: horaFormateada,
    };
  }

  // Método para formatear fecha
  formatearFecha(fechaISO) {
    if (!fechaISO) return null;

    try {
      const fecha = new Date(fechaISO);
      return fecha.toLocaleString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    } catch (error) {
      console.error("Error al formatear fecha:", error);
      return fechaISO; // Devolver original si hay error
    }
  }

  // Método para buscar item en datos de carrito
  buscarItemEnCarrito(customAttributes, itemId, itemName) {
    try {
      // Buscar el atributo de datos de carrito
      const atributoCarrito = customAttributes.find(
        (attr) => attr.key === "Datos Carrito PRoceso"
      );
      if (!atributoCarrito) return null;

      // Parsear los datos de carrito
      const datosCarrito = JSON.parse(atributoCarrito.value);
      if (!Array.isArray(datosCarrito)) return null;

      // Buscar por ID o nombre
      const idCorto = itemId.split("/").pop();

      // Primero intentar con ID exacto
      let itemEncontrado = datosCarrito.find(
        (item) =>
          item.id.toString() === idCorto ||
          item.variant_id.toString() === idCorto
      );

      // Si no encontramos por ID, buscar por nombre
      if (!itemEncontrado) {
        itemEncontrado = datosCarrito.find(
          (item) => item.title.toLowerCase() === itemName.toLowerCase()
        );
      }

      return itemEncontrado;
    } catch (error) {
      console.error("Error al buscar item en carrito:", error);
      return null;
    }
  }

  // Método auxiliar para procesar atributos personalizados
  procesarAtributosPersonalizados(atributos) {
    const resultado = {};

    // Procesar todos los atributos
    atributos.forEach((attr) => {
      // Procesar según el tipo de atributo
      if (attr.key === "Metodo Entrega") {
        resultado.metodoEntrega = attr.value;
      } else if (attr.key === "Datos Proceso Checkout") {
        try {
          resultado.datosCheckout = JSON.parse(attr.value);

          // Extraer información de pago
          if (resultado.datosCheckout.info_metodo_pago_seleccionado) {
            resultado.infoPago =
              resultado.datosCheckout.info_metodo_pago_seleccionado;
          }
        } catch (e) {
          console.error("Error al parsear datos de checkout:", e);
          resultado.datosCheckout = {
            error: "Error al parsear datos de checkout",
          };
        }
      } else if (attr.key === "Datos Carrito PRoceso") {
        try {
          resultado.datosCarrito = JSON.parse(attr.value);
        } catch (e) {
          console.error("Error al parsear datos de carrito:", e);
          resultado.datosCarrito = {
            error: "Error al parsear datos de carrito",
          };
        }
      } else {
        // Para otros atributos, mantener el nombre original
        try {
          if (attr.value.startsWith("{") || attr.value.startsWith("[")) {
            resultado[attr.key] = JSON.parse(attr.value);
          } else {
            resultado[attr.key] = attr.value;
          }
        } catch (e) {
          resultado[attr.key] = attr.value;
        }
      }
    });

    return resultado;
  }

  formatoTextosCombos(cantidad) {
    // Verificar si es un número válido
    if (typeof cantidad !== "number" || isNaN(cantidad) || cantidad < 0) {
      return "0 Combos";
    }
    // Singular si es 1, plural para el resto
    if (cantidad === 1) {
      return "1 Combo";
    } else {
      return `${cantidad} Combos`;
    }
  }

  btnVerMasDetallesClick() {
    this.seccionGeneralInfoBasica.style.display = "none";
    this.seccionSuperiorDetallePedido.style.display = "flex";
    this.seccionInferiorDetallePedido.style.display = "flex";
    this.btnVerMasDetalles.style.display = "none";
    this.btnVolverInicio.style.display = "none";
    this.btnVolverAtras.style.display = "flex";
  }

  btnVolverInicioClick() {
    // window.history.back();
    window.location.href = "/";
  }

  btnVolverAtrasClick() {
    if (this.estadoEtapaPagina == "etapa-2") {
      window.history.back();
    }
    //
    this.seccionGeneralInfoBasica.style.display = "flex";
    this.seccionSuperiorDetallePedido.style.display = "none";
    this.seccionInferiorDetallePedido.style.display = "none";
    this.btnVerMasDetalles.style.display = "flex";
    this.btnVolverInicio.style.display = "flex";
    this.btnVolverAtras.style.display = "none";
  }

  btnAbirUbicacionMapaClick() {
    console.log("Coordenadas: ", this.coordenadas);
    console.log("Abriendo mapa con coordenadas: ", this.coordenadas);
    const url = `https://www.google.com/maps/search/?api=1&query=${this.coordenadas.lat},${this.coordenadas.lng}`;
    window.open(url, "_blank");
  }
}

customElements.define("detalle-pedido", DetallePedido);
